/** @format */

import React, {useState} from 'react';
import {Button, TextLink} from '@sttark/design-system';
import CheckoutNewAccount from './new_account/checkout';
import CheckoutLoginContainer from './ajax_login/checkout';
import GoogleLoginButton from 'frontier/account/components/auth/google_login/google_signin_button';

export const CheckoutLogin = ({redirect}) => {
    // toggles whether to render the login or sign up component
    const [isLogin, setIsLogin] = useState(false);

    // toggle between login and sign up terminology
    const title = !isLogin ? 'Sign Up & Checkout' : 'Login & Checkout',
        subTitleDesc = !isLogin ? 'I already have an account' : 'I need to create an account';
    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="d-flex align-items-end justify-content-start auth_subtitle">
                    <h4 className="font-heading-lg content_sub-title mb-0 mt-0 ms-0 me-5">
                        {title}
                    </h4>
                    <span
                        onClick={() => {
                            setIsLogin(!isLogin);
                        }}>
                        <TextLink>{subTitleDesc}</TextLink>
                    </span>
                </div>
                <div className="mt-2">
                    <h4>Sign Up with Google Account</h4>
                    <GoogleLoginButton />
                </div>
            </div>

            {/* they are proceeding up with personal email  */}
            <div className="auth_with-email-container">
                {!isLogin ? (
                    <>
                        <p className="font-body-sm mx-0 mb-5 mt-0">
                            To create an account, we need a few details from you first.
                        </p>
                        <CheckoutNewAccount redirect={redirect} loginButtonLabel={title} />
                    </>
                ) : (
                    <>
                        <p className="font-body-sm mx-0 mb-5 mt-0">
                            To login and checkout, enter your email / username and password.
                        </p>
                        <CheckoutLoginContainer redirect={redirect} loginButtonLabel={title} />
                    </>
                )}
            </div>
        </>
    );
};
